import styled from 'styled-components';

import { Spinner, SpinnerSize } from '@creditornot/cb-progress';
import { ContentContainer } from 'common/components/cookbook/ContentContainer';
import { Typography as T } from 'common/components/cookbook/Typography/Typography';
import { useFormatMessage } from 'common/hooks/useFormatMessage';

const Root = styled(ContentContainer)`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
`;

type Props = {
  size?: SpinnerSize;
};

export const InfiniteScrollLoadingMore = ({ size = 'medium' }: Props) => {
  const f = useFormatMessage();
  return (
    <Root>
      <Spinner size={size} />
      <T.body>{f('warehouse.common.loading_more')}</T.body>
    </Root>
  );
};
